import {Button, Modal} from "react-bootstrap";
import {generateForm, handleSuccessMessage} from "../../utils/AppFunction";
import {Dispatch, SetStateAction, useContext, useEffect, useMemo, useState} from "react";
import {AppContext} from "../../appContext/AppContext";
import {ReportAssignmentContext} from "../ReportAssignment";
import {Form, Formik} from "formik";
import {updateTechnicalTransferPlan} from "../services/reportAssignment";
import {CODE, WF_TRACKER} from "../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../workflows/components/WfButton";
import {IconButtonSave} from "../../component/IconSvg";
import {PlanEmployee, TypeFormItem} from "../models/reportAssignment";
// import "../ChuyenGiaoKyThuat.scss";
import GenerateFormComponent from "../../component/generate-form/GenerateFormHTMLNoValid";
import ModalHeader from "../../component/ModalHeader";
import OCTTableCollapse from "../../component/table/table-collapse-custom/OctTableCollapse";
import {Columns} from "../columns/AssignEvaluation";
import {columnNamesTypeTableCollapse} from "@oceantech/oceantech-ui";
import {CRITERIA_TYPE, CRITERIA_TYPE_NAME} from "../../danh-muc/const/constant";


interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  type: TypeFormItem;
  setInitialValues: Dispatch<SetStateAction<any>>;
}

const AssignEvaluationDialog = (props: Props) => {
  const {show, onHide, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {detailItem, setDetailItem} = useContext(ReportAssignmentContext);

  const [isView, setIsView] = useState<boolean>(false);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [listEmployees, setListEmployees] = useState<any[]>([]);

  const columns: columnNamesTypeTableCollapse[] = useMemo(() => Columns({
    handleChangeRowInput: (index: number, value: any) => {}
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }), []);

  useEffect(() => {
    if (detailItem?.id) {
      setListEmployees(detailItem?.listEmployees || [
        {
          type: CRITERIA_TYPE.PHAN,
          name: "A. HƯỚNG ĐẾN NGƯỜI BỆNH",
          department: null,
          subs: [
            {
              type: CRITERIA_TYPE.CHUONG,
              name: "A1. CHỈ DẪN, TIẾP ĐÓN, HƯỚNG DẪN NGƯỜI BỆNH",
              department: null,
              subs: [
                {
                  type: CRITERIA_TYPE.TIEU_CHI,
                  name: "A1.1 Người bệnh cần được chỉ dẫn rõ ràng , đón tiếp .....",
                  department: null,
                  subs: [
                    {
                      type: CRITERIA_TYPE.TIEU_MUC,
                      name: "Thiếu biển hiệu bệnh viện hoặc biển hiệu....",
                      department: null,
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: CRITERIA_TYPE.PHAN,
          name: "B. PHÁT TRIỂN NGUỒN NHÂN LỰC BỆNH VIỆN",
          department: null,
          subs: []
        },
        {
          type: CRITERIA_TYPE.PHAN,
          name: "C. HOẠT ĐỘNG CHUYÊN MÔN",
          department: null,
          subs: []
        },
        {
          type: CRITERIA_TYPE.PHAN,
          name: "D. HOẠT ĐỘNG CHUYÊN MÔN",
          department: null,
          subs: []
        },
      ]);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues?.slipDto?.id]);

  useEffect(() => {
    updateForm();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFormSubmit = async () => {
    try {
      setIsLoading(true);
      const dataSubmit = {
        slipDto: {
          ...detailItem,
          listEmployees: listEmployees.map((item: any) => ({
          })),
        },
        trackerCode: type.trackerCode,
      };
      const res = await updateTechnicalTransferPlan(detailItem?.id, dataSubmit);
      const {data, code} = res.data;
      if (CODE.SUCCESS === code) {
        setDetailItem?.(data);
        handleSuccessMessage( detailItem?.id ? "update" : "create");
      } else {
        let errorMesage = data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
      return CODE.SUCCESS === code;
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const updateForm = async () => {
    if (type.form) {
      const data = await generateForm(type.form, setIsLoading);
      setListJsonGenerateVT(data || []);
    }
  };

  return (
    <Modal
      centered
      show={show}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleFormSubmit}
      >
        {({ values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <ModalHeader onHide={onHide} title="Phân công đánh giá" />
            <Modal.Body className="spaces p-0 bg-white">
              <div className="">
                <div className="spaces px-10">
                  <GenerateFormComponent
                    isView={isView}
                    listFieldAuto={listJsonGenerateVT}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    modelID={type.form}
                    DynamicClass={"pl-38"}
                  />
                </div>
                <div className="line-bottom"></div>
                <div className="mt-5">
                  <OCTTableCollapse
                    noAction
                    data={listEmployees}
                    columns={columns}
                    nameChildren="subs"
                    setData={(value: any) => { }}
                    selectData={(value: any) => { }}
                    searchObject={{}}
                    height={400}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-start bg-white spaces py-6 pl-5">
              {(detailItem?.id) && (
                <WfButton
                  additionalFunc={(data: any) => {
                    setDetailItem({
                      ...detailItem,
                      status: data?.currCode,
                      statusCode: data?.currCode,
                      statusId: data?.currId,
                    })
                  }}
                  handleClick={(data: any) => {
                    data.code === "allowed-edit" && setIsView(false);
                  }}
                  preActionHandler={handleFormSubmit}
                  tracker={WF_TRACKER.REPORT_ASSIGNMENT}
                  objectId={values[type.form]?.id || detailItem?.id}
                />
              )}
              {!isView &&
                <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                  <IconButtonSave /> Lưu
                </Button>
              }
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AssignEvaluationDialog;
